/**
 * @param {*} multipleCrossData dados a serem convertidos para o componente
 * de grafico simples
 * [{
        id: number,
        enunciado: string,
        alternativas: [{
            id: number,
            enunciado: string,
            resultado_numerico: number,
            resultado_percentual: string,
        }]
    }]
  @returns simpleChartData
  [
    {
      resultado_percentual: number;
      resultado_numerico: number;
      enunciado: string;
    }
  ]
 */

export function toSimpleChartData(multipleCrossData) {
  if (multipleCrossData.length === 0) {
    return [];
  }

  const firstQuestion = multipleCrossData[0];
  const simpleChartData = firstQuestion.alternativas.map((alternativa) => {
    // eslint-disable-next-line camelcase
    const { resultado_percentual, resultado_numerico, enunciado } = alternativa;
    return {
      resultado_percentual,
      resultado_numerico,
      enunciado,
    };
  });

  return simpleChartData;
}
